<template>
<div class="chapter">
<div class="inner_page">
<div class="wrap_small">
<p class="image"><a id="page_11"></a><img alt="image" src="images/f0011-01.jpg"/></p>
</div>
<h3><a id="pg11lev1"></a>JANUARY</h3>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/line2.jpg"/></p>
</div>
<h4><a id="pg11sec1"></a>JANUARY 1</h4>
<p class="first2_noindent">You are ambitious, studious, and original and have fine executive ability. You have self-respect and great personal charm. You are generous and affectionate and would make any sacrifice for your loved ones.</p>
<h4><a id="pg11sec2"></a>JANUARY 2</h4>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/line.jpg"/></p>
</div>
<p class="first2_noindent">Your love of family is your strongest characteristic and your greatest charm. Your very devotion and earnestness to succeed for them will help you gain your success. With your generous and happy nature, you will win loyal, true, and devoted friends.</p>
<h4><a id="page_12"></a><a id="pg12sec1"></a>JANUARY 3</h4>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/line.jpg"/></p>
</div>
<p class="first2_noindent">You are too apt to procrastinate and should practice diligence and perseverance because you are capable of greater things. You are friendly and enjoy meeting new people, and you have a strong personality. The friends you make are lasting ones.</p>
<h4><a id="pg12sec2"></a>JANUARY 4</h4>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/line.jpg"/></p>
</div>
<p class="first2_noindent">Yours is an energetic nature. You like to be doing things and seeing them well done. You have a faculty for making money, are shrewd, and have good business acumen. Those to whom you give your confidence will prove constant.</p>
<h4><a id="pg12sec3"></a>JANUARY 5</h4>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/line.jpg"/></p>
</div>
<p class="first2_noindent">You are exceedingly honest, kindhearted, loving, and fond of children. You adapt yourself readily but should curb your tendency to criticize others. Your love is deep, and your home is dear to you.</p>
<h4><a id="pg12sec4"></a>JANUARY 6</h4>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/line.jpg"/></p>
</div>
<p class="first2_noindent">You are impulsive; your actions are sometimes misunderstood and the motives misinterpreted. You think and act quickly and not always with good judgment. <a id="page_13"></a>Cultivate poise and self-restraint, or your passions will lead you into serious difficulties even though you have the best of intentions.</p>
<h4><a id="pg13sec1"></a>JANUARY 7</h4>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/line.jpg"/></p>
</div>
<p class="first2_noindent">Restrain your inclination to be exacting and domineering and learn to control your temper. You think a great deal of the opinion of others and strive to make a good impression. Choose a mate with sufficient character to stimulate your desire to be always at your best.</p>
<h4><a id="pg13sec2"></a>JANUARY 8</h4>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/line.jpg"/></p>
</div>
<p class="first2_noindent">You are self-reliant, cautious, shrewd, dependable, and, because you are intuitive, you can easily detect deception in others. You love music, art, and outdoor sports. You will always enjoy excellent health and should live to a ripe old age.</p>
<h4><a id="pg13sec3"></a>JANUARY 9</h4>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/line.jpg"/></p>
</div>
<p class="first2_noindent">You have a frank, energetic, and progressive nature and have faith in the good performed by others. Those born on this day achieve their greatest success by adhering to the belief that they themselves are the masters of their success.</p>
<h4><a id="page_14"></a><a id="pg14sec1"></a>JANUARY 10</h4>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/line.jpg"/></p>
</div>
<p class="first2_noindent">You are a natural leader and a good quick thinker. You would be successful in any commercial enterprise. Cultivate poise and do not be self-conscious or lacking in self-esteem. You attract the opposite sex and are unusually popular among your friends. Your love is true and loyal.</p>
<h4><a id="pg14sec2"></a>JANUARY 11</h4>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/line.jpg"/></p>
</div>
<p class="first2_noindent">You are kind, loyal, and winsome, but secretive. Once you become a friend, it is for all time, but, in your fidelity, you are apt to overlook serious faults in these friendships. You will find success in business, politics, or teaching. You will make a happy and congenial marriage.</p>
<h4><a id="pg14sec3"></a>JANUARY 12</h4>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/line.jpg"/></p>
</div>
<p class="first2_noindent">Your originality in everything you do, will, if cultivated, bring you happiness and remuneration. Your children will be mechanically inclined or artistic. You are naturally robust and strong, and, if you take care of yourself, you will never have any serious illness.</p>
<h4><a id="page_15"></a><a id="pg15sec1"></a>JANUARY 13</h4>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/line.jpg"/></p>
</div>
<p class="first2_noindent">You are unusually energetic, independent, ambitious, and persevering. Unless they work for themselves, people of this nature gain nothing when tied to others. By gaining poise and control of your temper, you will be happier and more successful in your business and social life.</p>
<h4><a id="pg15sec2"></a>JANUARY 14</h4>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/line.jpg"/></p>
</div>
<p class="first2_noindent">Never be satisfied with second best. Yours is the ability to do big things, and you are not easily discouraged. You have a sympathetic heart and concern yourself with the misfortunes of others. You are understanding and will make a loving parent, enjoy an ideal marriage, and have a happy home life.</p>
<h4><a id="pg15sec3"></a>JANUARY 15</h4>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/line.jpg"/></p>
</div>
<p class="first2_noindent">You are very original, shrewd, and keen of mind. You are a good manager, a careful buyer, and diplomatic. If you go into business, it should be your own. You should curb your tendency toward brusqueness with subordinates and learn to encourage friendships.</p>
<h4><a id="page_16"></a><a id="pg16sec1"></a>JANUARY 16</h4>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/line.jpg"/></p>
</div>
<p class="first2_noindent">You have courage, ambition, and singleness of purpose. You are sincere and just and should marry young. Do not try to analyze the motives and emotions of your love, and you will be sure of great happiness.</p>
<h4><a id="pg16sec2"></a>JANUARY 17</h4>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/line.jpg"/></p>
</div>
<p class="first2_noindent">Through perseverance and adapting yourself, you will gain success. You are fair-minded, just, and affectionate. You have great executive ability. Your true happiness will be found in a deep and trusting love.</p>
<h4><a id="pg16sec3"></a>JANUARY 18</h4>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/line.jpg"/></p>
</div>
<p class="first2_noindent">You have a great deal of personal strength and power, which you can use to your better advantage. You are prudent and thoughtful before acting, but when taken too far, you lean toward suspicion. You want to love and be loved in return, so don’t let an overabundance of caution keep you from finding the happiness you seek.</p>
<h4><a id="pg16sec4"></a>JANUARY 19</h4>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/line.jpg"/></p>
</div>
<p class="first2_noindent">Diplomats, writers, teachers, and lovers of the fine arts are born on this day. You have a kindly disposition, <a id="page_17"></a>consideration for others, and a desire to be helpful. Poetical, artistic, and affectionate, you are capable of entering into almost any profession or field and being successful.</p>
<h4><a id="pg17sec1"></a>JANUARY 20</h4>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/line.jpg"/></p>
</div>
<p class="first2_noindent">With more self-reliance, you are assured of success. Work honestly and diligently, and you will find happiness and pleasure in your work. March and November are the months in which you should begin important business. Tuesdays and Saturdays are your most favorable days.</p>
<h4><a id="pg17sec2"></a>JANUARY 21</h4>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/line.jpg"/></p>
</div>
<p class="first2_noindent">You are adaptable, fond of good times, easygoing, and somewhat apt to take things for granted. You enjoy traveling and will do a great deal of it. Your tendency toward selfishness will bring you unhappiness in later life unless you learn to curb it.</p>
<h4><a id="pg17sec3"></a>JANUARY 22</h4>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/line.jpg"/></p>
</div>
<p class="first2_noindent">You are self-reliant, diplomatic, and fond of dressing well, and you care a great deal for the good opinion of your friends and business associates. Though secretive, but not to the extent of trickery, you are affectionate <a id="page_18"></a>and lovable and should make a happy circle wherever you are.</p>
<h4><a id="pg18sec1"></a>JANUARY 23</h4>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/line.jpg"/></p>
</div>
<p class="first2_noindent">You are somewhat obstinate and difficult, and it is hard to drive you to do anything. Only those who know your weaknesses can rule you. You are well liked and respected by everyone. You will live a happily married life.</p>
<h4><a id="pg18sec2"></a>JANUARY 24</h4>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/line.jpg"/></p>
</div>
<p class="first2_noindent">Although you are good-natured, fair, and truthful, you are slightly inclined toward selfishness. You should marry early in life and choose a mate born in May, July, or November, and one spiritually inclined.</p>
<h4><a id="pg18sec3"></a>JANUARY 25</h4>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/line.jpg"/></p>
</div>
<p class="first2_noindent">A born leader, you should strive to make the most of this gift. With your friendly nature, you will be surrounded with congenial friends and your home life will be a constant inspiration. Take care that anger and jealousy do not get the better of your otherwise good judgment.</p>
<h4><a id="page_19"></a><a id="pg19sec1"></a>JANUARY 26</h4>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/line.jpg"/></p>
</div>
<p class="first2_noindent">Endowed with a great personal magnetism, you will always be surrounded by many people. Enjoy them! Your affections are not very deep, except to the one you will choose for your life partner. You are a true and loyal friend.</p>
<h4><a id="pg19sec2"></a>JANUARY 27</h4>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/line.jpg"/></p>
</div>
<p class="first2_noindent">You have great ambitions and desires, and they will take you far if you accept the help of others as you go along, instead of trampling them underfoot. Accept love as it comes to you, even when you think it retards your upward struggle.</p>
<h4><a id="pg19sec3"></a>JANUARY 28</h4>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/line.jpg"/></p>
</div>
<p class="first2_noindent">Make the most of the talents you are blessed with and ever aspire to greater things. Be cautious and prudent; never let your jealousy or envy of others come between you and your happiness. Put your trust in those worthy of it. You are sincere and you will win, through your sincerity, a deep and true love.</p>
<h4><a id="page_20"></a><a id="pg20sec1"></a>JANUARY 29</h4>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/line.jpg"/></p>
</div>
<p class="first2_noindent">You should take care in directing your natural ambition. Follow one chosen profession or calling faithfully and be thorough and painstaking in whatever you undertake. You are capable of loving deeply, and your marital and domestic life will be ideal.</p>
<h4><a id="pg20sec2"></a>JANUARY 30</h4>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/line.jpg"/></p>
</div>
<p class="first2_noindent">You are capable of exerting a great deal of influence over those with whom you come in contact, and you should be careful in using it. Develop your mind to the extent of its capabilities. You are not demonstrative, but you can and will love with a true, strong passion.</p>
<h4><a id="pg20sec3"></a>JANUARY 31</h4>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/line.jpg"/></p>
</div>
<p class="first2_noindent">You are ambitious, but you can be easily discouraged. Do not give up; you can accomplish many things if you stay on course and cultivate perseverance and confidence in your own ability. You are kind, just, and generous and have an artistic temperament.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07-chapter01.vue?0426f1ea